import _ from 'lodash';
import { sortByCount } from '../../../../../../../utils/helper';
import { getProviderName } from '../../../../helpers/getters';
import { modifierServiceTypesToObject } from '../../../../helpers/modifiers';
import { modifierSplittingRows, modifierListAfterFiltersSearch } from '../../../../helpers/listModifiers';

/**
 *
 * @param {number} value
 * @returns {string|*}
 */
export const getTypeBtnName = (value) => {
  if (_.isNumber(value)) {
    const types = modifierServiceTypesToObject();
    if (types[value]) {
      return types[value].name;
    }
  }
  return 'Type';
};

/**
 *
 * @param startList
 * @param filters
 * @param search
 * @returns {[]}
 */
export const getCurrentServicesId = (startList, filters, search) => {
  const checked = [];
  const listAfterFilter = modifierListAfterFiltersSearch(startList, filters, search);
  const list = modifierSplittingRows(listAfterFilter, {
    withOutShowHideCategory: true,
  });
  if (list) {
    list.forEach((row) => {
      if (row.collection === 'service') {
        checked.push(row.id);
      }
    });
  }
  return checked;
};

/**
 *
 * @param categories
 * @returns {*}
 */
export const providersList = (categories) => {
  const list = modifierSplittingRows(categories, {
    withOutShowHideCategory: true,
  });
  let manualCount = 0;
  const providers = list.reduce((obj, row) => {
    const mode = Number(row.mode);
    if (row.collection === 'service') {
      if (mode) {
        const providerId = row.provider_id;
        if (providerId) {
          if (obj[providerId]) {
            obj[providerId].count++;
          } else {
            const providerName = getProviderName(providerId, mode);
            obj[providerId] = {
              id: providerId,
              value: providerId,
              label: providerName,
              count: 1,
            };
          }
        }
      } else {
        manualCount++;
      }
    }
    return obj;
  }, {});

  const providersList = Object.values(providers).sort(sortByCount);

  if (manualCount) {
    providersList.unshift({
      id: null,
      value: 'manual',
      label: 'Manual',
      count: manualCount,
    });
  }
  return providersList;
};

/**
 *
 * @param {array} categories
 * @returns {{length}|*[]}
 */
export const serviceTypeList = (categories) => {
  const types = modifierServiceTypesToObject();
  const list = modifierSplittingRows(categories, {
    withOutShowHideCategory: true,
  });

  let allCount = 0;
  const typesListObject = list.reduce((obj, row) => {
    if (row.collection === 'service') {
      if (types[row.type]) {
        allCount++;
        const type = types[row.type];
        if (obj[row.type]) {
          obj[row.type].count++;
        } else {
          obj[row.type] = {
            id: type.id,
            name: type.name,
            count: 1,
          };
        }
      }
      return obj;
    }
    return obj;
  }, {});

  const allObj = {
    id: null,
    name: 'All',
    count: allCount,
  };

  const typeList = Object.values(typesListObject);
  if (typeList.length) {
    const sortTypeList = typeList.sort(sortByCount);
    sortTypeList.unshift(allObj);
    return sortTypeList;
  }
  return [];
};

/**
 *
 * @param {array} categories
 * @returns {({name: string, count: number, value: number} | {name: string, count: number, value: null} | {name: string, count: number, value: number})[]|*[]}
 */
export const statusesList = (categories) => {
  const list = modifierSplittingRows(categories, {
    withOutShowHideCategory: true,
  });
  const statuses = {
    all: {
      name: 'All',
      count: 0,
      value: null,
    },
    disabled: {
      name: 'Disabled',
      count: 0,
      value: 0,
    },
    enabled: {
      name: 'Enabled',
      count: 0,
      value: 1,
    },
  };

  if (list && _.isArray(list)) {
    list.forEach((row) => {
      if (row.collection === 'service') {
        const status = Number(row.status);
        if (!_.isNaN(status)) {
          if (status === 1) {
            statuses.enabled.count++;
          }
          if (status === 0) {
            statuses.disabled.count++;
          }
        }
        statuses.all.count++;
      }
    });
  }
  return statuses.all.count ? Object.values(statuses) : [];
};

/**
 *
 * @param {array} categories
 * @returns {{length}|*[]}
 */
export const subcategoriesOptions = (categories) => {
  const list = modifierSplittingRows(categories, {
    withOutShowHideCategory: true,
  });

  let allCount = 0;
  let otherCount = 0;
  const subcategoriesObj = {};
  list.forEach((row) => {
    if (row.collection === 'service') {
      allCount += 1;
      if (row.subcategory) {
        if (subcategoriesObj[row.subcategory]) {
          subcategoriesObj[row.subcategory].count += 1;
        } else {
          subcategoriesObj[row.subcategory] = {
            label: row.subcategory,
            value: row.subcategory,
            count: 1,
          }
        }
      } else {
        otherCount += 1;
      }
    }
  })

  const listToArray = Object.keys(subcategoriesObj).map((key) => {
    const subcategory = subcategoriesObj[key];
    return { ...subcategory }
  }).sort(sortByCount);

  if (allCount) {
    return [
      {
        label: 'All',
        value: null,
        count: allCount,
      },
      ...listToArray,
      {
        label: 'Other',
        value: 'Other',
        count: otherCount,
      },
    ]
  }

  return [];
};

/**
 *
 * @param {number} value
 * @returns {string|*}
 */
export const getSubcategoryBtnName = (value) => {
  if (value) {
    return value;
  }
  return 'Service';
};
